import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  "data": {
    "networkStatus": {
      "router": {
        "offline": 0,
        "online": 2
      },
      "ap": {
        "offline": 1,
        "online": 12
      },
      "switch": {
        "offline": 1,
        "online": 5
      },
      "client": {
        "online": 285,
        "offline": 42
      }
    },
    "cpuTop5": [
      {
        "name": "Core-Switch-01",
        "percentage": 43.2,
        "deviceId": "3C:33:32:14:A2:00"
      },
      {
        "name": "Edge-Switch-02",
        "percentage": 40.5,
        "deviceId": "BC:22:28:25:07:32"
      },
      {
        "name": "Gateway-Router",
        "percentage": 38.7,
        "deviceId": "BC:22:21:15:20:39"
      },
      {
        "name": "AP-Lobby-Main",
        "percentage": 35.1,
        "deviceId": "00:7A:82:33:44:53"
      },
      {
        "name": "AP-Meeting-Room",
        "percentage": 32.8,
        "deviceId": "3C:33:32:14:A2:01"
      }
    ],
    "memTop5": [
      {
        "name": "Core-Switch-01",
        "percentage": 68.9,
        "deviceId": "3C:33:32:14:A2:00"
      },
      {
        "name": "Gateway-Router",
        "percentage": 65.3,
        "deviceId": "BC:22:21:15:20:39"
      },
      {
        "name": "Edge-Switch-03",
        "percentage": 62.7,
        "deviceId": "BC:22:28:25:07:36"
      },
      {
        "name": "AP-Conference-A",
        "percentage": 60.4,
        "deviceId": "00:7A:82:55:66:77"
      },
      {
        "name": "AP-Office-West",
        "percentage": 58.1,
        "deviceId": "BC:22:28:25:07:38"
      }
    ],
    "poeTop5": [
      {
        "name": "SW-Floor1-Core",
        "consumption": 245.8,
        "budget": 370.0,
        "deviceId": "3C:33:32:14:A2:00"
      },
      {
        "name": "SW-Lobby-Access",
        "consumption": 158.4,
        "budget": 240.0,
        "deviceId": "BC:22:28:25:07:32"
      },
      {
        "name": "SW-Meeting-Wing",
        "consumption": 86.2,
        "budget": 120.0,
        "deviceId": "BC:22:28:25:07:39"
      },
      {
        "name": "SW-Guest-Lounge",
        "consumption": 62.1,
        "budget": 90.0,
        "deviceId": "BC:22:28:25:07:40"
      },
      {
        "name": "SW-Lab-Testing",
        "consumption": 41.9,
        "budget": 120.0,
        "deviceId": "BC:22:28:25:07:41"
      }
    ],
    "pocConsumption": [
      {
        "budget": 1000.0,
        "consumption": 594.4
      }
    ],
    "top5TrafficApSsid": [
      {
        "name": "Corporate-WiFi",
        "totalTx": 18904321098,
        "totalRx": 15654321098,
        "usage": 34558642196,
        "rateAvg": 128.9,
        "ratePeak": 580.5,
        "deviceId": "00:7A:82:33:44:53"
      },
      {
        "name": "Guest-Access",
        "totalTx": 9543210987,
        "totalRx": 8678901234,
        "usage": 18222112221,
        "rateAvg": 72.3,
        "ratePeak": 320.1,
        "deviceId": "00:7A:82:55:66:75"
      },
      {
        "name": "IoT-Devices",
        "totalTx": 4321098765,
        "totalRx": 3987654321,
        "usage": 8308753086,
        "rateAvg": 22.1,
        "ratePeak": 110.9,
        "deviceId": "BC:22:28:25:07:33"
      },
      {
        "name": "Voice-Over-IP",
        "totalTx": 3210987654,
        "totalRx": 2987654321,
        "usage": 6198641975,
        "rateAvg": 45.6,
        "ratePeak": 180.7,
        "deviceId": "BC:22:28:25:07:34"
      },
      {
        "name": "Staging-Test",
        "totalTx": 2109876543,
        "totalRx": 1987654321,
        "usage": 4097530864,
        "rateAvg": 18.9,
        "ratePeak": 90.3,
        "deviceId": "BC:22:28:25:07:35"
      }
    ],
    "top5TrafficSwitch": [
      {
        "name": "SW-Core-01",
        "totalTx": 59876543210,
        "totalRx": 48765432105,
        "usage": 108641975315,
        "rateAvg": 485.3,
        "ratePeak": 1280.2,
        "deviceId": "3C:33:32:14:A2:00"
      },
      {
        "name": "SW-Access-Lobby",
        "totalTx": 2543219876,
        "totalRx": 2432198765,
        "usage": 4975418641,
        "rateAvg": 82.1,
        "ratePeak": 420.5,
        "deviceId": "BC:22:28:25:07:31"
      },
      {
        "name": "SW-Conf-Room-A",
        "totalTx": 1821987654,
        "totalRx": 1587654321,
        "usage": 3409641975,
        "rateAvg": 68.9,
        "ratePeak": 310.3,
        "deviceId": "00:7A:82:55:66:77"
      },
      {
        "name": "SW-Guest-Wing",
        "totalTx": 1210987654,
        "totalRx": 1087654321,
        "usage": 2298641975,
        "rateAvg": 48.7,
        "ratePeak": 240.4,
        "deviceId": "00:7A:82:44:55:66"
      },
      {
        "name": "SW-Lab-Section",
        "totalTx": 909876543,
        "totalRx": 887654321,
        "usage": 1797530864,
        "rateAvg": 35.2,
        "ratePeak": 150.8,
        "deviceId": "00:7A:82:33:44:55"
      }
    ],
    "top5TrafficAp": [
      {
        "name": "AP-Meeting-Room-01",
        "totalTx": 18904321098,
        "totalRx": 17654321098,
        "usage": 36558642196,
        "rateAvg": 168.9,
        "ratePeak": 880.5,
        "deviceId": "3C:33:32:14:A2:01"
      },
      {
        "name": "AP-Executive-Suite",
        "totalTx": 16543210987,
        "totalRx": 15678901234,
        "usage": 32222112221,
        "rateAvg": 152.3,
        "ratePeak": 720.1,
        "deviceId": "00:7A:82:22:33:42"
      },
      {
        "name": "AP-Lobby-Main",
        "totalTx": 14321098765,
        "totalRx": 13987654321,
        "usage": 28308753086,
        "rateAvg": 142.1,
        "ratePeak": 680.9,
        "deviceId": "00:7A:82:33:44:53"
      },
      {
        "name": "AP-Warehouse-South",
        "totalTx": 11210987654,
        "totalRx": 10987654321,
        "usage": 22198641975,
        "rateAvg": 115.6,
        "ratePeak": 540.7,
        "deviceId": "00:7A:82:44:55:64"
      },
      {
        "name": "AP-Guest-Cafeteria",
        "totalTx": 8109876543,
        "totalRx": 7987654321,
        "usage": 16097530864,
        "rateAvg": 88.9,
        "ratePeak": 490.3,
        "deviceId": "00:7A:82:55:66:75"
      }
    ],
    "apChannelUtilization": [
      {
        "band": "2.4GHz",
        "channel": 1,
        "total": 3,
        "devices": [
          { "id": "00:7A:82:44:55:64", "name": "AP-Warehouse-South" },
          { "id": "00:7A:82:33:44:66", "name": "AP-Guest-Lobby" },
          { "id": "00:7A:82:33:44:77", "name": "AP-Office-North" }
        ]
      },
      {
        "band": "5GHz",
        "channel": 36,
        "total": 4,
        "devices": [
          { "id": "00:7A:82:33:44:88", "name": "AP-Meeting-A" },
          { "id": "00:7A:82:33:44:99", "name": "AP-Meeting-B" },
          { "id": "00:7A:82:22:33:42", "name": "AP-Executive-Suite" },
          { "id": "00:7A:82:33:44:BB", "name": "AP-Finance" }
        ]
      }
    ],
    "wirelessTrafficUsage": {
      "wirelessTrafficUsageRx": [
        { "timestamp": 1733956800, "usage": 1888250000.75 },
        { "timestamp": 1733957400, "usage": 1444320000.40 },
        { "timestamp": 1733958000, "usage": 2100000000.00 },
        { "timestamp": 1733958600, "usage": 2500000000.00 },
        { "timestamp": 1733959200, "usage": 2300000000.00 }
      ],
      "wirelessTrafficUsageTx": [
        { "timestamp": 1733956800, "usage": 43434980000.30 },
        { "timestamp": 1733957400, "usage": 10323250000.60 },
        { "timestamp": 1733958000, "usage": 35000000000.00 },
        { "timestamp": 1733958600, "usage": 48000000000.00 },
        { "timestamp": 1733959200, "usage": 42000000000.00 }
      ]
    },
    "accessPointsOverview": {
      "client": [
        { "apName": "AP-Lobby-Main", "clientCounts": 65 },
        { "apName": "AP-Conf-Room-A", "clientCounts": 58 },
        { "apName": "AP-Office-West", "clientCounts": 45 },
        { "apName": "AP-Office-East", "clientCounts": 42 },
        { "apName": "AP-Guest-Café", "clientCounts": 38 },
        { "apName": "Others", "clientCounts": 37 }
      ],
      "traffic": [
        { "apName": "AP-Lobby-Main", "usage": 45000000000.5 },
        { "apName": "AP-Conf-Room-A", "usage": 38000000000.2 },
        { "apName": "AP-Office-West", "usage": 21000000000.0 },
        { "apName": "AP-Office-East", "usage": 19500000000.5 },
        { "apName": "AP-Guest-Café", "usage": 18000000000.1 },
        { "apName": "Others", "usage": 15000000000.3 }
      ]
    },
    "wirelessClientsRssi": [
      {
        "rssi": ">= -55 dBm",
        "clientCounts": 185,
        "clientList": [
          { "clientId": "00:11:22:33:44:66", "clientName": "iPhone-15-Pro" },
          { "clientId": "00:11:22:33:44:55", "clientName": "MacBook-Pro-16" },
          { "clientId": "client-03", "clientName": "Samsung-S24" },
          { "clientId": "client-04", "clientName": "iPad-Pro" }
        ]
      },
      {
        "rssi": "-70 to -55 dBm",
        "clientCounts": 75,
        "clientList": [
          { "clientId": "client-05", "clientName": "Dell-Latitude-7440" },
          { "clientId": "client-06", "clientName": "ThinkPad-X1-Carbon" }
        ]
      },
      {
        "rssi": "< -70 dBm",
        "clientCounts": 25,
        "clientList": [
          { "clientId": "client-07", "clientName": "Pixel-8-Pro" }
        ]
      }
    ],
    "wirelessClientsBand": [
      { "band": "2.4GHz", "clientCounts": 45 },
      { "band": "5GHz", "clientCounts": 165 },
      { "band": "6GHz", "clientCounts": 60 },
      { "band": "MLO", "clientCounts": 15 }
    ],
    "top5TrafficWirelessClients": [
      {
        "clientName": "MacBook-Pro-16",
        "usage": 8532342430.5,
        "totalTx": 5042340000.0,
        "totalRx": 3490002430.5,
        "rateAvg": 152.2,
        "ratePeak": 850.0,
        "clientId": "00:11:22:33:44:55"
      },
      {
        "clientName": "iPhone-15-Pro",
        "usage": 4232342430.5,
        "totalTx": 1242340000.0,
        "totalRx": 2990002430.5,
        "rateAvg": 82.5,
        "ratePeak": 450.0,
        "clientId": "00:11:22:33:44:66"
      },
      {
        "clientName": "Dell-XPS-15",
        "usage": 3532342430.5,
        "totalTx": 1542340000.0,
        "totalRx": 1990002430.5,
        "rateAvg": 65.8,
        "ratePeak": 380.0,
        "clientId": "00:11:22:33:44:77"
      },
      {
        "clientName": "iPad-Air",
        "usage": 2132342430.5,
        "totalTx": 442340000.0,
        "totalRx": 1690002430.5,
        "rateAvg": 42.1,
        "ratePeak": 210.0,
        "clientId": "00:11:22:33:44:88"
      },
      {
        "clientName": "Samsung-Galaxy-S23",
        "usage": 1532342430.5,
        "totalTx": 542340000.0,
        "totalRx": 990002430.5,
        "rateAvg": 28.6,
        "ratePeak": 150.0,
        "clientId": "00:11:22:33:44:99"
      }
    ],
    "top5WirelessClientsAp": [
      { "apName": "AP-Lobby-Main", "deviceId": "00:7A:82:33:44:53", "clientCounts": 65 },
      { "apName": "AP-Conf-Room-A", "deviceId": "00:7A:82:55:66:77", "clientCounts": 58 },
      { "apName": "AP-Office-West", "deviceId": "BC:22:28:25:07:38", "clientCounts": 45 },
      { "apName": "AP-Office-East", "deviceId": "00:11:22:33:44:04", "clientCounts": 42 },
      { "apName": "AP-Guest-Cafeteria", "deviceId": "00:7A:82:55:66:75", "clientCounts": 38 }
    ],
    "wirelessClientsActivities": [
      { "timestamp": 1735584000, "new": 12, "existing": 245, "disconnected": 5 },
      { "timestamp": 1735587600, "new": 8, "existing": 252, "disconnected": 10 },
      { "timestamp": 1735591200, "new": 15, "existing": 250, "disconnected": 12 },
      { "timestamp": 1735594800, "new": 22, "existing": 260, "disconnected": 8 },
      { "timestamp": 1735598400, "new": 18, "existing": 274, "disconnected": 4 }
    ]
  }
}

export const dashboardStatsSlice = createSlice({
  name: "dashboardStats",
  initialState,
});

export default dashboardStatsSlice.reducer;